/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ToolMetadata, ToolMetadata$inboundSchema } from "./toolmetadata.js";

/**
 * Result type for listing tool metadata
 */
export type ListToolMetadataResult = {
  /**
   * The stored tool metadata for the MCP server
   */
  tools: Array<ToolMetadata>;
};

/** @internal */
export const ListToolMetadataResult$inboundSchema: z.ZodMiniType<
  ListToolMetadataResult,
  unknown
> = z.object({
  tools: z.array(ToolMetadata$inboundSchema),
});

export function listToolMetadataResultFromJSON(
  jsonString: string,
): SafeParseResult<ListToolMetadataResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListToolMetadataResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListToolMetadataResult' from JSON`,
  );
}
